module.exports = __webpack_public_path__ + "static/media/food_map_thumb_home.c7db5788.jpg";